import { secondsToHms } from '@/utils/timeUtils';
import { AgentDetail } from '../../agent-performance/agentTableTypes';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { formatPercentage } from '@/lib/utils';

// Extend dayjs with relativeTime plugin
dayjs.extend(relativeTime);

/**
 * transferredRate value
 * <=20%: green (positive)
 * >20% and <=60%: orange (moderate)
 * >60%: red (negative)
 */
export function getTransferredRateColor(transferredRate?: number): string {
  if (!transferredRate) return '';
  if (transferredRate <= 20) {
    return 'text-green-600 dark:text-green-400';
  } else if (transferredRate <= 60) {
    return 'text-orange-600 dark:text-orange-400';
  } else {
    return 'text-red-600 dark:text-red-400';
  }
}

/**
 * SLA value
 * >=85%: green (positive)
 * >=70% and <85%: orange (moderate)
 * <70%: red (negative)
 */
export function getSlaColor(sla?: number): string {
  if (!sla) return '';
  if (sla >= 85) {
    return 'text-green-600 dark:text-green-400';
  } else if (sla >= 70) {
    return 'text-orange-600 dark:text-orange-400';
  } else {
    return 'text-red-600 dark:text-red-400';
  }
}

/**
 * Helper function to format values based on column type
 */
export function formatValue(key: string, item: AgentDetail): string {
  if (!item) return '';
  
  switch (key) {
    case 'displayName':
      return item.queueName || '';
    case 'totalHandledCalls':
      return item.totalHandledCalls?.toString() || '0';
    case 'transferredCalls':
      return item.callIdsTransferredRate?.length?.toString() || '0';
    case 'totalAnsweredDuration':
      return item.totalAnsweredDuration ? secondsToHms(item.totalAnsweredDuration) : '00:00:00';
    case 'averageHandleTime':
      return item.averageHandleTime ? secondsToHms(item.averageHandleTime) : '00:00:00';
    case 'transferredRate':
      return item.transferredRate ? `${formatPercentage(item.transferredRate)}` : 'No calls transferred';
    case 'sla':
      return item.sla ? `${formatPercentage(item.sla)}` : 'No information';
    case 'lastCallTakenSecond': {
      return item?.lastCallTakenSecond;
    }
    default:
      return '';
  }
}
